import Vue from 'vue';
import { APIHelper } from '@archistarai/auth-frontend';

export default {
  namespaced: true,
  state: {
    billings: [],
    billingType: {
      Credit: 'Credit Card',
      Debit: 'Direct Debit',
      Invoice: 'Invoice'
    },
    billingMethod: ['stripe', 'stripedebit', 'xero'],
    countryIncGst: 'Australia'
  },
  getters: {
    billingWhereUser(state) {
      return (guid) => state.billings.filter((s) => s.user_guid === guid);
    },
    billingFind(state) {
      return (guid) => state.billings.find((s) => s.billing_guid === guid);
    }
  },
  mutations: {
    ADD_BILLINGS(state, billings) {
      billings.forEach((billing) => {
        const index = state.billings.findIndex((b) => b.billing_guid === billing.billing_guid);
        if (index >= 0) {
          // replace existing billing
          Vue.set(state.billings, index, billing);
        } else {
          // not in list
          state.billings.push(billing);
        }
      });
    },
    ADD_BILLING(state, billing) {
      const index = state.billings.findIndex((s) => s.billing_guid === billing.billing_guid);
      if (index >= 0) {
        // replace existing billing
        Vue.set(state.billings, index, billing);
      } else {
        // not in list
        state.billings.push(billing);
      }
    }
  },
  actions: {
    async getBillingsForUser({ state, commit }, { guid, force = false, type = null }) {
      if (!force && state.billings.some((s) => s.user_guid === guid)) {
        //check if already have features
        return state.billings.filter((s) => s.user_guid === guid);
      }
      let typeQuery = '';
      if (type && type.includes(state.billingMethod)) {
        typeQuery = `&billing_type=${type}`;
      }
      try {
        const {
          data: { data: billings }
        } = await APIHelper.AdminAPI.get(`/billings?scope=user&guid=${guid}${typeQuery}`);
        commit('ADD_BILLINGS', billings);
        return billings;
      } catch (e) {
        throw e;
      }
    }
  }
};
